import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Translate = () => {
    const [originalText, setOriginalText] = useState('');
    const [translatedText, setTranslatedText] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const [sourceLanguage, setSourceLanguage] = useState("en");
    const [isTranslating, setIsTranslating] = useState(false);
    const [isCopySuccess, setIsCopySuccess] = useState(false);
    const [translationLanguages, setTranslationLanguages] = useState([]);

    useEffect(() => {
        const fetchTranslationLanguages = async () => {
            const options = {
                method: 'GET',
                url: 'https://google-translate113.p.rapidapi.com/api/v1/translator/support-languages',
                headers: {
                    'X-RapidAPI-Key': 'google-translate-api key from rapid api',
                    'X-RapidAPI-Host': 'google-translate113.p.rapidapi.com'
                }
            };

            try {
                const response = await axios.request(options);
                // console.log(response.data);
                setTranslationLanguages(response.data);
            } catch (error) {
                console.error('Error fetching translation languages', error);
            }
        };

        fetchTranslationLanguages();
    }, []);

    const handleTranslate = async () => {
        try {
            setIsTranslating(true);


            // Check if sourceLanguage is different from selectedLanguage
            if (sourceLanguage !== selectedLanguage) {
                const encodedParams = new URLSearchParams();
                encodedParams.set('from', sourceLanguage);
                encodedParams.set('to', selectedLanguage);
                encodedParams.set('text', originalText);

                const options = {
                    method: 'POST',
                    url: 'https://google-translate113.p.rapidapi.com/api/v1/translator/text',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        'X-RapidAPI-Key': 'google-translate-api key from rapid api',
                        'X-RapidAPI-Host': 'google-translate113.p.rapidapi.com'
                    },
                    data: encodedParams,
                };

                const translationResponse = await axios.request(options);

                const translatedText = translationResponse.data.trans;


                setTranslatedText(translatedText);
                setSourceLanguage(selectedLanguage);
            } else {
                const encodedParams = new URLSearchParams();
                encodedParams.set('from', 'auto');
                encodedParams.set('to', selectedLanguage);
                encodedParams.set('text', originalText);

                const options = {
                    method: 'POST',
                    url: 'https://google-translate113.p.rapidapi.com/api/v1/translator/text',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        'X-RapidAPI-Key': 'google-translate-api key from rapid api',
                        'X-RapidAPI-Host': 'google-translate113.p.rapidapi.com'
                    },
                    data: encodedParams,
                };

                const translationResponse = await axios.request(options);

                const translatedText = translationResponse.data.trans;

                setTranslatedText(translatedText);
                setSourceLanguage(selectedLanguage);
            }

            setIsTranslating(false);
        } catch (error) {
            console.error('Error translating text', error);
        } finally {
            setIsTranslating(false);
        }
    };

    const handleCopyTranslatedText = () => {
        navigator.clipboard.writeText(translatedText);
        setIsCopySuccess(true);
        setTimeout(() => {
            setIsCopySuccess(false);
        }, 3000);
    };

    const handleLanguageChange = (languageName) => {
        setSelectedLanguage(languageName);
    };

    return (
        <div className="p-8 text-center bg-gradient w-full font-primary mb-10">
            <div className="absolute top-0 left-[55%] overlay-glow2"></div>
            <div className="mb-8 w-[85%] mx-auto">
                <label
                    className="mb-5 inline-block dark:text-neutral-200 text-4xl text-light text-center font-bold my-3"
                    htmlFor="originalText"
                >
                    Original Text
                </label>
                <textarea
                    className="w-full p-4 border border-[#ad53e5] rounded-md resize-none"
                    rows="4"
                    id="originalText"
                    value={originalText}
                    onChange={(e) => setOriginalText(e.target.value)}
                    disabled={isTranslating}
                />
            </div>

            <div className="w-[100%] flex flex-wrap flex-col gap-4 md:gap-1 md:flex-row items-center justify-center mb-8">
                {/* <label className="mr-2 text-white">Select Target Language:</label> */}
                <select
                    value={selectedLanguage}
                    onChange={(e) => handleLanguageChange(e.target.value)}
                    className="px-4 py-2 border border-gray-300 rounded-md max-sm:px-2 max-sm:py-1"
                    disabled={isTranslating}
                >
                    {translationLanguages.map((languageObj) => (
                        <option key={languageObj.code} value={languageObj.code}>
                            {languageObj.language}
                        </option>
                    ))}
                </select>
                <button
                    className="bg-gradient2 font-semibold text-white px-6 py-3 ml-2 max-sm:mt-3 rounded-md"
                    onClick={handleTranslate}
                    disabled={!originalText || isTranslating}
                >
                    {isTranslating ? 'Translating...' : 'Translate'}
                </button>
            </div>

            <div className="bg-gray-100 p-8 mb-8 text-left rounded-md w-[85%] mx-auto">
                <div className="mb-4">
                    <label className="mr-2 font-semibold">Translated Text:</label>
                    <div className="border border-[#ad53e5] p-4 rounded-md h-40 overflow-auto">
                        {translatedText}
                    </div>
                    <button
                        onClick={handleCopyTranslatedText}
                        className={`text-white bg-blue-500 px-4 py-2 rounded-md mt-4 ${isCopySuccess ? 'cursor-not-allowed' : 'cursor-pointer'
                            }`}
                        disabled={!translatedText || isTranslating || isCopySuccess}
                    >
                        {isCopySuccess ? 'Copied!' : 'Copy Translated Text'}
                    </button>
                </div>
            </div>

            {isTranslating && <div className="text-gray-500">Translating...</div>}
        </div>
    );
};

export default Translate;
